"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
import type { SelectableIdentityOption } from "@/components/utils/input/profile-search/getSelectableIdentity";
import { ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted } from "@/generated/models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted";
interface CreateDropIdentityPickerModalProps {
  readonly isOpen: boolean;
  readonly mode: ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted;
  readonly selectedIdentity: SelectableIdentityOption | null;
  readonly disabled: boolean;
  readonly errorMessage: string | null;
  readonly canClose: boolean;
  readonly onClose: () => void;
  readonly onSelect: (selection: SelectableIdentityOption) => void;
}
const getHelperText = (mode: ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted) => {
  switch (mode) {
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.OnlyOthers:
      return "Search for someone else to nominate.";
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.Everyone:
      return "Search for the identity you want to nominate.";
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.OnlyMyself:
      return "Your identity will be used automatically.";
  }
};
export default function CreateDropIdentityPickerModal(t0) {
  const $ = _c(23);
  const {
    isOpen,
    mode,
    selectedIdentity,
    disabled,
    errorMessage,
    canClose,
    onClose,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== mode) {
    t1 = getHelperText(mode);
    $[0] = mode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="tw-mb-6 tw-text-sm tw-font-normal tw-text-iron-400">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = selectedIdentity?.value ?? null;
  const t4 = selectedIdentity?.label ?? null;
  let t5;
  if ($[4] !== onSelect) {
    t5 = selection => {
      if (selection) {
        onSelect(selection);
      }
    };
    $[4] = onSelect;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !!errorMessage;
  let t7;
  if ($[6] !== errorMessage || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <IdentitySearch identity={t3} selectedDisplayValue={t4} setIdentity={_temp} onSelectionChange={t5} label="Search identity" size={IdentitySearchSize.MD} autoFocus={true} clearable={false} dropdownListClassName="tw-max-h-[50vh] md:tw-max-h-96 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300" error={t6} errorMessage={errorMessage} />;
    $[6] = errorMessage;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== disabled) {
    t8 = disabled && <p className="tw-mb-0 tw-mt-3 tw-text-xs tw-font-medium tw-text-iron-500">Identity selection is disabled while the drop is submitting.</p>;
    $[12] = disabled;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t2 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-px-4 sm:tw-px-6">{t2}{t7}{t8}</div>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== canClose || $[19] !== isOpen || $[20] !== onClose || $[21] !== t9) {
    t10 = <MobileWrapperDialog title="Select identity" isOpen={isOpen} onClose={onClose} dismissible={canClose} tabletModal={true} allowOverflow={true} maxWidthClass="md:tw-max-w-xl">{t9}</MobileWrapperDialog>;
    $[18] = canClose;
    $[19] = isOpen;
    $[20] = onClose;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp() {}